import { ValuesOf } from "../../foundation/random";
import { StartEndOptions } from "../start-end/start-end";
import { NatGenTextField } from "./text-field";

/**
 * Text field sub-types
 * @public
 */
export const TextFieldType = {
    /**
     * An email TextField
     */
    email: "email",

    /**
     * A password TextField
     */
    password: "password",

    /**
     * A telephone TextField
     */
    tel: "tel",

    /**
     * A text TextField
     */
    text: "text",

    /**
     * A URL TextField
     */
    url: "url",
} as const;

/**
 * Types for the text field sub-types
 * @public
 */
export type TextFieldType = ValuesOf<typeof TextFieldType>;

/**
 * Text field configuration options
 * @public
 */
export type TextFieldOptions = StartEndOptions<NatGenTextField>;
